/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/9/18
 * Time: 19:44
 * Desc: 营销中心-秒杀活动-订单明细
 */

import { Component, Vue, Prop } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

@Component
export default class SeckillOrderDetail extends Vue {
  /* 属性 */

  /**
   * 秒杀Id
   * @type {number}
   */
  @Prop({ default: 0 }) skId: number;

  /* 数据 */

  /**
   * 页码
   * @type {number}
   */
  public page = 1;

  /**
   * 条数
   * @type {number}
   */
  public pageSize = 10;

  /**
   * 总条数
   * @type {number}
   */
  public totalCount = 0;

  /**
   * 关键字
   * @type {string}
   */
  public keywords = '';

  /**
   * 订单明细列表
   * @type<Array<OrderDetailList>>
   */
  public orderDetailList: Array<OrderDetailList> = [];

  /**
   * 订单状态
   * @type {string}
   */
  public orderState = '';

  /* 方法 */

  /**
   * 关键字搜索
   * @return null
   */
  public onSearchOrderDetailList(): void {
    this.page = 1;
    this.pageSize = 10;
    this.getOrderDetailList();
  }

  /**
   * 条数变更
   * @param {number} val
   * @return null
   */
  public onSizeChange(val: number): void {
    this.page = 1;
    this.pageSize = val;
    this.getOrderDetailList();
  }

  /**
   * 页码变更
   * @return null
   */
  public onPageChange(val: number): void {
    this.page = val;
    this.getOrderDetailList();
  }

  /**
   * 订单状态变化
   * @type {string} val
   * @return null
   */
  public onOrderStateChange(val: string): void {
    this.orderState = val;
    this.getOrderDetailList();
  }

  /**
   * 获取秒杀订单列表
   * @return null
   */
  public getOrderDetailList(): void {
    const loading = this.$loading({
      lock: true,
      text: '请稍等...',
      spinner: 'el-icon-loading',
      background: 'rgba(225,225,225,0.3)',
    });
    const postParams = {
      skId: this.skId,
      keyword: this.keywords,
      isPost: this.orderState === '' ? 9 : Number.parseInt(this.orderState),
      page: this.page,
      pageSize: this.pageSize,
    };
    IPSService.secKillOrderList({ postParams })
      .then((res) => {
        loading.close();
        this.totalCount = res.count;
        if (res.list.length > 0) {
          res.list.forEach((item: any) => {
            item.buyerName = Functions.emptyVaribleHandler(item.buyerName);
            item.specValue = Functions.emptyVaribleHandler(item.specValue);
            item.orderAddTime = Functions.timeFormatSec(item.orderAddTime);
            item.orderPayTime = Functions.timeFormatSec(item.orderPayTime);
          });
        }
        this.orderDetailList = res.list;
      })
      .catch(() => {
        loading.close();
      });
  }

  /**
   *  清理数据
   *  @return null
   */
  public onClearData(): void {
    this.page = 1;
    this.pageSize = 10;
    this.orderDetailList = [];
  }

  /**
   * 关闭弹窗
   * @return null
   */
  public onClosePop(): void {
    this.$emit('onOrderDetailListHide'); // 关闭明细弹窗
  }
}
